<nav class="navbar navbar-expand-lg navbar-light bg-light primary">
	<span class="navbar-brand"><img src="../../assets/images/nesten-logo.png" alt="" class="img-fluid" style="height: 40px;"></span>
	<span class="headerSpace"></span>
	<i class="fa fa-bars" aria-hidden="true" (click)="openDialog()" style="font-size: x-large; cursor:pointer;"></i>
</nav>
<div class="main-div">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-11">
        <h2 class="title">Transaction History</h2>
        <div class="form-holder">
            <!-- <h3 class="text-white text-center">Your Transactions</h3> -->
          <div *ngIf="!processing">
              <div *ngIf="OutTxListLength == 0 && InTxListLength == 0">
                  <h3 class="text-white text-center">No Transactions Yet.</h3>
                </div>
                <div *ngIf="OutTxListLength != 0 || InTxListLength != 0">
                <div class="justify-content-between">

                    <div data-toggle="buttons" class="text-right btn-group-toggle">
                        <label class="btn btn-sqr" [class.primary]="Out"  [class.btn-secondary]="!Out">
                            <input type="radio" autocomplete="off" checked (click)="toggleOutFromOut()"> Out Transactions
                        </label>
                        <label class="btn btn-sqr" [class.primary]="!Out" [class.btn-secondary]="Out">
                            <input type="radio" autocomplete="off" (click)="toggleOutFromIn()"> In Transactions
                        </label>
                    </div>
                </div>
                <div class="table-responsive" *ngIf="OutTxListLength != 0">
                    <table class="table table-bordered bg-light table-striped" *ngIf="Out">
                        <thead class="thead-dark">
                            <tr>
                                <th>Block #</th>
                                <th>TX Hash</th>
                                <th>Receiver Address</th>
                                <th>Value</th>
                                <th>Timestamp</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let txs of OuttransactionList; let i = index">
                                <td>{{txs.tx.blockNumber}}</td>
                                <td title="{{txs.tx.hash}}" class="txHash"><a href="https://explorer.nitwallet.io/tx/{{txs.tx.hash}}" target="_blank">{{txs.tx.hash | slice:0:8}}...</a></td>
                                <td title="{{txs.tx.to}}">{{txs.tx.to | slice:0:8}}...</td>
                                <td>{{txs.tx.value | convertnit}} NIT</td>
                                <td>{{txs.tx.timestamp*1000 | date:'dd/MM/y, hh:mm a'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <div>
                  <div class="col-md-4 mb-2">
                    <button mat-stroked-button class="primary solid-gradient-btn btn-block" (click)="next(1)">Next</button>
                  </div>
                  <div class="col-md-4 mb-2">
                    <button mat-stroked-button class="primary solid-gradient-btn btn-block" (click)="previous(1)">Previous</button>
                  </div>
                </div> -->
                <div *ngIf="OutTxListLength == 0 && Out">
                  <h4 class="text-white text-center">No Out Transactions</h4>
                </div>
                <div class="table-responsive" *ngIf="InTxListLength != 0">
                  <table class="table table-bordered bg-light table-striped" *ngIf="!Out">
                      <thead class="thead-dark">
                          <tr>
                              <th>Block #</th>
                              <th>TX Hash</th>
                              <th>Sender Address</th>
                              <th>Value</th>
                              <th>Timestamp</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr *ngFor="let txs of IntransactionList; let i = index">
                              <td>{{txs.tx.blockNumber}}</td>
                              <td title="{{txs.tx.hash}}" class="txHash"><a  href="https://explorer.nitwallet.io/tx/{{txs.tx.hash}}" target="_blank">{{txs.tx.hash | slice:0:8}}...</a></td>
                              <td title="{{txs.tx.from}}">{{txs.tx.from | slice:0:8}}...</td>
                              <td>{{txs.tx.value | convertnit}} NIT</td>
                              <td>{{txs.tx.timestamp*1000 | date:'dd/MM/y, hh:mm a'}}</td>
                          </tr>
                      </tbody>
                  </table>
                </div>
                <!-- <div>
                  <div class="col-md-4 mb-2">
                    <button mat-stroked-button class="primary solid-gradient-btn btn-block" (click)="next(2)">Next</button>
                  </div>
                  <div class="col-md-4 mb-2">
                    <button mat-stroked-button class="primary solid-gradient-btn btn-block" (click)="previous(2)">Previous</button>
                  </div>
                </div> -->
                <div *ngIf="InTxListLength == 0 && !Out">
                  <h4 class="text-white text-center">No In Transactions</h4>
                </div>
              </div>
          </div>
          <div class="spinDiv w-100" *ngIf="processing">
							<div >
								<mat-spinner class="mat-spinner-color"></mat-spinner>
								<div class="text-white">Processing...</div>
							</div>
            </div>
            <div class="pagination-cnt d-flex justify-content-between" *ngIf="OutTxListLength != 0 && Out">
              <nav aria-label="Page navigation example" >
                <ul class="pagination justify-content-center">
                  <li class="page-item" *ngIf="outCurrSlice>0" style="cursor: pointer">
                    <a class="page-link" (click)="showOutTxHistory(outCurrSlice-1)" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </a>
                  </li>
                  <li class="page-item"><a class="page-link">Page {{outCurrSlice+1}} of {{totalOutPages}}</a></li>

                  <li class="page-item" *ngIf="outCurrSlice+1<totalOutPages" style="cursor: pointer">
                    <a class="page-link" (click)="showOutTxHistory(outCurrSlice+1)" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </a>
                  </li>
                </ul>
              </nav>
              <nav aria-label="...">
                <ul class="pagination">
                  <li class="page-item" >
                    <input type="number" class="form-control"  placeholder="Go to page" [(ngModel)]="OutSearchPage">
                  </li>
                  <li class="page-item">
                    <button class="page-link" (click)="jumpEvent(OutSearchPage,'outtxs')">Search</button>
                  </li>
                </ul>
              </nav>
            </div>

            <div class="pagination-cnt d-flex justify-content-between" *ngIf="InTxListLength != 0 && !Out">
              <nav aria-label="Page navigation example">
                <ul class="pagination justify-content-center">
                  <li class="page-item" *ngIf="inCurrSlice>0" style="cursor: pointer">
                    <a class="page-link" (click)="showInTxHistory(inCurrSlice-1)" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </a>
                  </li>
                  <li class="page-item"><a class="page-link">Page {{inCurrSlice+1}} of {{totalInPages}}</a></li>

                  <li class="page-item" *ngIf="inCurrSlice+1<totalInPages" style="cursor: pointer">
                    <a class="page-link" (click)="showInTxHistory(inCurrSlice+1)" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </a>
                  </li>
                </ul>
              </nav>
              <nav aria-label="...">
                <ul class="pagination">
                  <li class="page-item" >
                    <input type="number" class="form-control"  placeholder="Go to page" [(ngModel)]="InSearchPage">
                  </li>
                  <li class="page-item">
                    <button class="page-link" (click)="jumpEvent(InSearchPage,'intx')">Search</button>
                  </li>
                </ul>
              </nav>
            </div>


        <div class="row mb-4">
          <div class="col-md-4 mb-2">
            <button mat-stroked-button class="justify-content-center primary solid-gradient-btn btn-block" (click)="backToDashboard()">Back</button>
          </div>
        </div>
        <div>
      </div>
    </div>
  </div>
</div>
